export const environment = {
  production: true,
  // root_url: 'http://127.0.0.1:7891',
  // root_url: 'http://68.183.219.229:7891',
  // root_url: 'https://api.bgiethiopia.com',
  root_url: 'https://api.bgiethiopia.com',
  // root_url: 'https://api.bgiadmin.com',
};
